import { Lato, Montserrat } from "next/font/google";
import "../styles/styles.scss";
import { GoogleTagManager } from "@next/third-parties/google";

const LatoFont = Lato({
  weight: ["400", "700"],
  subsets: ["latin"],
  display: "swap",
  preload: true,
});

const MontserratFont = Montserrat({
  weight: ["600", "700"],
  subsets: ["latin"],
  display: "swap",
  preload: true,
});

export default function App({ Component, pageProps }) {
  const gtmId = process.env.IS_LIVE ? "GTM-T2Z27J" : "GTM-KMSLVD";

  return (
    <>
      <style jsx global>{`
        :root {
          --font-primary: ${LatoFont.style.fontFamily};
          --font-secondary: ${MontserratFont.style.fontFamily};
        }
      `}</style>
      <Component {...pageProps} />
      <GoogleTagManager gtmId={gtmId} />
    </>
  );
}
